module.exports = __webpack_public_path__ + "img/urbanmp.9cb9f0f0.jpeg";